<template>
  <div class="scoreStep">
    <div v-for="(item, i) in list" :key="i" class="item">
      <div class="top">
        <div class="left" :style="{ background: item.left }"></div>
        <div :class="[item.value <= active ? 'lightDot' : 'dot']"></div>
        <div class="right" :style="{ background: item.right }"></div>
      </div>
      <div class="nameBox">
        <p class="name" :style="{ color: item.value <= active ? black : gray }">
          {{ item.name }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
const normal = 'rgba(216, 216, 216, 1)'
const abnormal = 'rgba(255, 0, 0, 1)'
const black = 'rgba(60, 60, 60, 1)'
const gray = 'rgba(153, 153, 153, 1)'
import lang from '@/langs'
const props = defineProps({
  activeValue: {
    // 下拉区域始终为全屏的高度
    type: Number,
    default: 0
  }
})
const list = ref([
  {
    name: lang('线下汇款'),
    value: 0,
    left: 'transparent',
    right: normal
  },
  { name: lang('填写申请'), value: 1, left: normal, right: normal },
  {
    name: lang('充值结果'),
    value: 2,
    left: normal,
    right: 'transparent'
  }
])
watch(
  () => props.activeValue,
  (value) => {
    statusFn(value)
  }
)
const active = ref(props.activeValue)
const statusFn = (value: number) => {
  active.value = value
  if (value === 0) {
    list.value[0].right = normal
    list.value[1].right = normal
    list.value[1].left = normal
    list.value[2].left = normal
  } else if (value === 1) {
    list.value[0].right = abnormal
    list.value[1].right = normal
    list.value[1].left = abnormal
    list.value[2].left = normal
  } else {
    list.value[0].right = abnormal
    list.value[1].right = abnormal
    list.value[1].left = abnormal
    list.value[2].left = abnormal
  }
}
statusFn(active.value)
</script>

<style scoped lang="less">
.scoreStep {
  display: flex;
  flex-direction: row;
  padding-top: 22px;
  background: #fff;
  padding-bottom: 22px;
  .item {
    display: flex;
    flex: 3;
    flex-direction: column;
    //align-items: center;
    .top {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 11px;
      .left {
        flex: 2;
        height: 1.5px;
        background: blue;
      }
      .dot {
        width: 8px;
        height: 8px;
        border-radius: 50px;
        background: rgba(216, 216, 216, 1);
      }
      .lightDot {
        width: 8px;
        height: 8px;
        border-radius: 50px;
        background: rgba(255, 0, 0, 1);
        box-shadow: 0 0 0 3px rgba(255, 0, 0, 0.2);
      }
      .right {
        flex: 2;
        height: 1.5px;
        background: green;
      }
    }
    .nameBox {
      flex: 1;
      justify-content: center;
      //align-items: center;
      display: flex;
      .name {
      }
    }
  }
}
</style>
